import { SafetyNetEligibilityCtrl } from './safety-net-eligibility.controller';

export const SafetyNetEligibilityStepComponent = {
  controller: SafetyNetEligibilityCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./safety-net-eligibility.html'),
};
